import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AnalyticsEvent, AnalyticsService } from '../../../core/services/analytics-service';
import { CustomerStoreService } from '../../../core/services/customer-store.service';
import { DobryPradForm } from '../../forms/dobry-prad.form';
import { OffersStoreService } from '../../services/offers-store.service';

@Component({
standalone: false,
  selector: 'app-dobry-prad-offer-form',
  styleUrls: ['./dobry-prad-offer-form.component.scss'],
  templateUrl: './dobry-prad-offer-form.component.html',
})
export class DobryPradOfferFormComponent implements OnInit {
  @Input() public customerBillerId: string;
  @Output() public action: EventEmitter<void> = new EventEmitter<void>();

  public form: DobryPradForm;

  constructor(private customerStoreService: CustomerStoreService, private offerService: OffersStoreService,
              private analyticsService: AnalyticsService) {
  }

  public ngOnInit(): void {
    const customer = this.customerStoreService.state;
    this.form = new DobryPradForm(customer.phoneNumber);
  }

  public prepareOffer(): void {
    this.form.markAllAsTouched();

    if (this.form.valid) {
      this.offerService.prepareDobryPradOffer(this.form.getFinalData()).subscribe(() => {
        this.analyticsService.trackEvent(new AnalyticsEvent('Dobry Prad form sent'));
        this.action.next();
      });

    }
  }
}
